import React, { forwardRef } from 'react';

import { cn } from '@lyearn/style';
import { Stack } from '@lyearn/ui';
import { DateDisplay } from '@lyearn/ui';
import useKeyboard from '@/modules/corporate/modules/database/fields/hooks/useKeyboard';
import { CellProps } from '@/modules/corporate/modules/database/types';

import { getDisplayDate } from './utils';

const DateCell = forwardRef<HTMLDivElement, CellProps>((props, ref) => {
  const { cellData, toggleIsEditing, columnIndex, rowIndex, className } = props;

  const { onKeyDown } = useKeyboard({ onEnterPress: toggleIsEditing });

  const startDate = getDisplayDate(cellData?.value, cellData?.metadata?.d?.timeFormat);
  const endDate = getDisplayDate(cellData?.metadata?.d?.endDate, cellData?.metadata?.d?.timeFormat);

  return (
    <Stack
      ref={ref}
      alignItems="center"
      className={cn('h-full w-full cursor-pointer truncate py-8 pe-6 ps-12', className)}
      data-colindex={columnIndex}
      data-rowindex={rowIndex}
      tabIndex={0}
      onClick={toggleIsEditing}
      onKeyDown={onKeyDown}>
      <DateDisplay endDate={endDate} startDate={startDate} />
    </Stack>
  );
});

export default DateCell;
